import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { styled } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import SecurityIcon from "@mui/icons-material/Security";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MuseumIcon from '@mui/icons-material/Museum';
import DevicesIcon from '@mui/icons-material/Devices';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import GroupsIcon from '@mui/icons-material/Groups';
import IMTime from '../components/IMTime';
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import GlobalDataEntry from '../components/GlobalDataEntry';
import WarehouseLogistics from '../components/Warehouse&Logistics';
import IMTransport from '../components/IMTransport';
import IMWarehouse from '../components/IMWarehouse';
import Securebase from '../components/Securebase';
import ONEIL from '../components/ONEIL';
import Gorpa from '../components/Gorpa';
import ImWorkforce from '../components/ImWorkforce';
import Crozier from '../components/Crozier';
import UserDetails from '../components/UserDetails'
import { useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";
import Badge from '@mui/material/Badge';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; 
import LogIt from '../components/LogIT';
import OnDeviceTrainingIcon from '@mui/icons-material/OnDeviceTraining';
import PIT from '../components/PIT';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import NRCOrderManagement from '../components/NRCOrderManagement';
import IMCollections from '../components/IMCollections';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      style={{width:'80vw', maxWidth: '80vw', height:'calc(100vh - 160px)'}} 
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const StyledTab = styled(Tab)({
  textTransform:'none',
  fontSize: '1rem',
  justifyContent:'left',
  '&.Mui-selected': {
    backgroundColor: '#EBF7FF',
    color: '#1b75bc',
  },
  '&:hover': {
      color: 'black',
      opacity: 1,
      backgroundColor: "#E5E5E5"
    },
})
const StyledTab1 = styled(Tab)({
  textTransform:'none',
  fontSize: '1rem',
  justifyContent:'left',
  '&.Mui-selected': {
    backgroundColor: '#1b75ac',
    color: 'white'
  },
})
const StyledTabs = styled(Tabs)({
  ".MuiTabs-scrollButtons.Mui-disabled": {
    opacity: 0.3
  }
})
const VerticalTabsComponent = () => {
  const location = useLocation();
  const empId = location.state && location.state.empId ? location.state.empId : '';
  const workerDocument = useSelector(state => state.addEditWorker.workerDocument || {});
  const enabledRoles = useSelector(state => state.addEditWorker.enabledRoles || {});
  const workerData = location.state && location.state.worker ? location.state.worker : null;
  const workerName = workerData?.workerId ? 
                    (workerData?.firstName || "") + " " 
                    + (workerData?.lastName || "")+"'s" : "";
  const [value, setValue] = useState(0);
  const [enableApplications, seEnableApplications] = useState(false);

  console.log("enabledRoles", enabledRoles)

  useEffect(() => {
    if(workerData?.workerId || workerDocument?.workerId){
      seEnableApplications(true);
    }
  } ,[workerDocument])

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    
    <Box>
      <Box
      sx={{bgcolor: 'background.paper',marginTop: 0, display: 'flex',borderRight: 2, paddingLeft: 2, borderColor: 'divider'}}
    >
      <StyledTabs
        variant="scrollable"
        scrollButtons
        orientation="vertical"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{paddingRight: 2, height:"calc(100vh - 160px)", width:"20vw", maxWidth:325, minWidth:255}}
      >
        <StyledTab1 iconPosition="start" icon={<></>}  label={`${workerData?.workerId ? workerName :"Worker"} Profile`} {...a11yProps(0)} sx={{minHeight: '45px', textAlign: 'left'}}/>
        <hr id='customHr2'/>
        <Typography sx={{marginLeft: 1.5, marginTop: 1}} variant='h6'>Applications</Typography>
        <StyledTab iconPosition="start" icon={<AccessTimeIcon/>} 
          label={  
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', textAlign:'left', width:'100%' }}>
                  IM Time
                {enabledRoles?.timeRole &&
                    <CheckCircleIcon style={{ marginLeft: '8px', color: '#1b75ac' }} />
                }
              </span>
            } 
          {...a11yProps(1)} sx={{minHeight: '45px'}} disabled={!enableApplications} />
        <StyledTab iconPosition="start" icon={<KeyboardIcon/>}
         label={  
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', textAlign:'left', width:'100%' }}>
              Global Data Entry
            {enabledRoles?.gde &&
                <CheckCircleIcon style={{ marginLeft: '8px', color: '#1b75ac' }} />
            }
          </span>
          } 
          {...a11yProps(2)} sx={{minHeight: '45px'}} disabled={!enableApplications}/>
        <StyledTab iconPosition="start" icon={<EmojiTransportationIcon/>}
          label={  
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', textAlign:'left', width:'100%' }}>
              Warehouse & Logistics
            {enabledRoles?.SBS &&
                <CheckCircleIcon style={{ marginLeft: '8px', color: '#1b75ac' }} />
            }
          </span>
          } 
          {...a11yProps(3)} sx={{minHeight: '45px'}} disabled={!enableApplications}/>
        <StyledTab iconPosition="start" icon={<LocalShippingIcon/>} 
         label={  
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', textAlign:'left', width:'100%' }}>
              IM Transport
            {enabledRoles?.transportation &&
                <CheckCircleIcon style={{ marginLeft: '8px', color: '#1b75ac' }} />
            }
          </span>
          } 
          {...a11yProps(4)} sx={{minHeight: '45px'}} disabled={!enableApplications}/>
        <StyledTab iconPosition="start" icon={<WarehouseIcon/>}
        label={  
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', textAlign:'left', width:'100%' }}>
              IM Warehouse
            {enabledRoles?.imWarehouse &&
                <CheckCircleIcon style={{ marginLeft: '8px', color: '#1b75ac' }} />
            }
          </span>
          } 
          {...a11yProps(5)} sx={{minHeight: '45px'}} disabled={!enableApplications}/>
        <StyledTab iconPosition="start" icon={<SecurityIcon/>}
        label={  
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', textAlign:'left', width:'100%' }}>
              Securebase
            {enabledRoles?.SECUREBASE &&
                <CheckCircleIcon style={{ marginLeft: '8px', color: '#1b75ac' }} />
            }
          </span>
          } 
          {...a11yProps(6)} sx={{minHeight: '45px'}} disabled={!enableApplications}/>
        <StyledTab iconPosition="start" icon={<AnalyticsOutlinedIcon/>}
        label={  
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', textAlign:'left', width:'100%' }}>
              ONEIL
            {enabledRoles?.ONEIL &&
                <CheckCircleIcon style={{ marginLeft: '8px', color: '#1b75ac' }} />
            }
          </span>
          } 
          {...a11yProps(7)} sx={{minHeight: '45px'}} disabled={!enableApplications}/>
        <StyledTab iconPosition="start" icon={<HealthAndSafetyIcon/>}
          label={  
            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', textAlign:'left', width:'100%' }}>
                GORPA
              {enabledRoles?.gorpa &&
                  <CheckCircleIcon style={{ marginLeft: '8px', color: '#1b75ac' }} />
              }
            </span>
            } 
          {...a11yProps(8)} sx={{minHeight: '45px'}} disabled={!enableApplications}/>
        <StyledTab iconPosition="start" icon={<GroupsIcon/>}
          label={  
            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', textAlign:'left', width:'100%' }}>
                IM Workforce
              {enabledRoles?.imWorkforce &&
                  <CheckCircleIcon style={{ marginLeft: '8px', color: '#1b75ac' }} />
              }
            </span>
            } 
          {...a11yProps(11)} sx={{minHeight: '45px'}} disabled={!enableApplications}/>
        <StyledTab iconPosition="start" icon={<MuseumIcon/>}
          label={  
            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', textAlign:'left', width:'100%' }}>
                CROZIER
              {enabledRoles?.crozier &&
                  <CheckCircleIcon style={{ marginLeft: '8px', color: '#1b75ac' }} />
              }
            </span>
            } 
          {...a11yProps(12)} sx={{minHeight: '45px'}} disabled={!enableApplications}/>
           <StyledTab iconPosition="start" icon={<DevicesIcon />}
              label={  
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', textAlign:'left', width:'100%' }}>
                    LogIT
                  {enabledRoles?.logIT &&
                      <CheckCircleIcon style={{ marginLeft: '8px', color: '#1b75ac' }} />
                  }
                </span>
                } 
          {...a11yProps(13)} sx={{minHeight: '45px'}} disabled={!enableApplications}/>
           {/* <StyledTab iconPosition="start" icon={<OnDeviceTrainingIcon />}
              label={  
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', textAlign:'left', width:'100%' }}>
                    PIT
                  {enabledRoles?.PIT &&
                      <CheckCircleIcon style={{ marginLeft: '8px', color: '#1b75ac' }} />
                  }
                </span>
                } 
          {...a11yProps(13)} sx={{minHeight: '45px'}} disabled={!enableApplications}/> */}
           <StyledTab iconPosition="start" icon={<Inventory2Icon />}
              label={  
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', textAlign:'left', width:'100%' }}>
                    NRC
                  {enabledRoles?.NRC &&
                      <CheckCircleIcon style={{ marginLeft: '8px', color: '#1b75ac' }} />
                  }
                </span>
                } 
          {...a11yProps(14)} sx={{minHeight: '45px'}} disabled={!enableApplications}/> 
          <StyledTab iconPosition="start" icon={<CollectionsBookmarkIcon />}
              label={  
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', textAlign:'left', width:'100%' }}>
                    IM Collections
                  {enabledRoles?.imCollections &&
                      <CheckCircleIcon style={{ marginLeft: '8px', color: '#1b75ac' }} />
                  }
                </span>
                } 
          {...a11yProps(15)} sx={{minHeight: '45px'}} disabled={!enableApplications}/>
      </StyledTabs>
      <TabPanel value={value} index={0}>
      <UserDetails/>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <IMTime handleChange={handleChange}/>
      </TabPanel>
      <TabPanel value={value} index={4}>
      <GlobalDataEntry handleChange={handleChange}/>
      </TabPanel>
      <TabPanel value={value} index={5}>
      <WarehouseLogistics handleChange={handleChange}/>
      </TabPanel>
      <TabPanel value={value} index={6}>
      <IMTransport handleChange={handleChange}/>
      </TabPanel>
      <TabPanel value={value} index={7}>
      <IMWarehouse handleChange={handleChange}/>
      </TabPanel>
      <TabPanel value={value} index={8}>
      <Securebase handleChange={handleChange}/>
      </TabPanel>
      <TabPanel value={value} index={9}>
      <ONEIL handleChange={handleChange}/>
      </TabPanel>
      <TabPanel value={value} index={10}>
      <Gorpa handleChange={handleChange}/>
      </TabPanel>
      <TabPanel value={value} index={11}>
      <ImWorkforce handleChange={handleChange}/>
      </TabPanel>
      <TabPanel value={value} index={12}>
      <Crozier handleChange={handleChange}/>
      </TabPanel>
      <TabPanel value={value} index={13}>
      <LogIt handleChange={handleChange}/>
      </TabPanel>
      {/* <TabPanel value={value} index={13}>
      <PIT handleChange={handleChange}/>
      </TabPanel> */}
      <TabPanel value={value} index={14}>
      <NRCOrderManagement handleChange={handleChange}/>
      </TabPanel>
      <TabPanel value={value} index={15}>
      <IMCollections handleChange={handleChange}/>
      </TabPanel>
    </Box>
    </Box>
  );
}

export default VerticalTabsComponent;